import React from 'react';
import { render } from 'react-dom';
import JobsFilter from '../components/JobsFilter';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('jobs-filter-app');

  if (!node) {
    return;
  }

  const props = {
    categories: JSON.parse(node.dataset.categories),
  };

  render(
    <JobsFilter {...props} />,
    node,
  );
});
